import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

const addReaction = (body: any) =>
  reactQueryPost(internalApi.reactions.reactions(), body);

const removeReaction = (body: any) =>
  reactQueryDelete(internalApi.reactions.reactions(), body);

const fetchCommunityMemberDetails = (params: any) =>
  reactQueryGet(internalApi.reactions.communityMembers(params));

export const reactionsApi = {
  addReaction,
  removeReaction,
  fetchCommunityMemberDetails,
};
